import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 8 * 2,
    margin: `0 0 ${8}px 0`,

    // change background colour if dragging
    background: isDragging ? "#4971b2" : "#fff",
    color: isDragging ? "#fff" : "#000",
    borderRadius: 5,

    // styles we need to apply on draggables
    ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "#e5f5fd",
    padding: 8,
    height: "60vh",
    overflowY: "scroll",
    width: "100%",
    margin: 10,
    borderRadius: 5,
});

const useDragDropforTestimonials = (state, setState, onUpdate) => {
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const move = (source, destination, droppableSource, droppableDestination) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;
        return result;
    };

    function onDragEnd(result) {
        const { source, destination } = result;

        if (!destination) return;

        const sInd = +source.droppableId;
        const dInd = +destination.droppableId;

        let newState = [...state];

        if (sInd === dInd) {
            const items = reorder(state[sInd], source.index, destination.index);
            newState[sInd] = items;
        } else {
            const result = move(state[sInd], state[dInd], source, destination);
            newState[sInd] = result[sInd];
            newState[dInd] = result[dInd];
        }

        setState(newState);

        // 🔥 trigger callback so parent can call mapTestimonial
        if (onUpdate) {
            onUpdate(newState);
        }
    }

    const DragDrop = () => (
        <DragDropContext onDragEnd={onDragEnd}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                {state.map((el, ind) => (
                    <div key={ind} style={{ width: "48%" }}>
                        <h5
                            style={{
                                textAlign: "center",
                                marginBottom: "10px",
                                fontWeight: "600",
                                color: "#01204c",
                            }}
                        >
                            {ind === 0 ? "State Testimonials" : "Mapped Testimonials"}
                        </h5>

                        <Droppable droppableId={`${ind}`}>
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                    {...provided.droppableProps}
                                >
                                    {el.map((item, index) => (
                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "10px",
                                                        }}
                                                    >
                                                        {item.image && (
                                                            <img
                                                                src={item.image}
                                                                alt={item.name}
                                                                style={{
                                                                    width: 50,
                                                                    height: 50,
                                                                    borderRadius: "50%",
                                                                }}
                                                            />
                                                        )}
                                                        <div>
                                                            <div style={{ fontWeight: "500" }}>{item.name}</div>
                                                            <div
                                                                style={{
                                                                    fontSize: "12px",
                                                                    color: "#555",
                                                                }}
                                                            >
                                                                {item.rank} ({item.year})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                ))}
            </div>
        </DragDropContext>
    );


    return [DragDrop];
};

export default useDragDropforTestimonials;
